import React, { useState } from 'react';
import '../App.css';
import { Navbar, Nav, Container, Modal } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import {
  FaPhone,
  FaMapMarkerAlt,
  FaClock,
  FaDonate,
  FaCalendarAlt,
  FaPhotoVideo,
  FaChurch,
  FaHome,
  FaBookOpen,
  FaTelegram,
  FaBars
} from 'react-icons/fa';

function Navig() {
  const [showContacts, setShowContacts] = useState(false);
  const [showSchedule, setShowSchedule] = useState(false);

  return (
    <header>
      <div className="top-info-bar">
        <Container className="top-info-content">
          <a href="tel:+79184249395" className="top-info-link" aria-label="Позвонить в храм">
            <FaPhone /> +7 (918) 424-93-95
          </a>
          <span className="top-info-link"><FaMapMarkerAlt /> ст. Даховская, ул. Клубная, 16А</span>
          <button type="button" className="top-info-link top-info-button" onClick={() => setShowSchedule(true)}>
            <FaClock /> Расписание богослужений
          </button>
        </Container>
      </div>

      <div className="site-header-wrap">
        <Container>
          <div className="site-header-brand">
            <img src={require('../images/georgiy.jpeg')} alt="Икона святого Георгия" className="site-header-icon" />
            <div>
              <p className="site-header-overline">Православный приход</p>
              <h1 className="site-header-title">Храм Великомученика и Победоносца Георгия</h1>
              <p className="site-header-subtitle">Станица Даховская, Майкопский район</p>
            </div>
          </div>
        </Container>
      </div>

      <Navbar expand="lg" className="main-navbar" sticky="top">
        <Container>
          <Navbar.Toggle aria-controls="main-menu" className="main-navbar-toggle">
            <FaBars />
            <span>Меню</span>
          </Navbar.Toggle>
          <Navbar.Collapse id="main-menu">
            <Nav className="align-items-lg-center nav-links">
              <Nav.Link as={Link} to="/" className="main-nav-link"><FaHome /> Главная</Nav.Link>
              <Nav.Link as={Link} to="/photo" className="main-nav-link"><FaPhotoVideo /> Фотогалерея</Nav.Link>
              <Nav.Link onClick={() => setShowContacts(true)} className="main-nav-link"><FaPhone /> Контакты</Nav.Link>
              <Nav.Link onClick={() => setShowSchedule(true)} className="main-nav-link"><FaCalendarAlt /> Расписание</Nav.Link>
              <Nav.Link as={Link} to="/donate" className="main-nav-link donate-link"><FaDonate /> Пожертвования</Nav.Link>
              <Nav.Link as={Link} to="/building" className="main-nav-link"><FaChurch /> Строительство</Nav.Link>
              <Nav.Link as={Link} to="/khram" className="main-nav-link"><FaBookOpen /> О святом Георгии</Nav.Link>
            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>

      <Modal show={showContacts} onHide={() => setShowContacts(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title>Контакты храма</Modal.Title>
        </Modal.Header>
        <Modal.Body className="church-modal-body">
          <p><FaMapMarkerAlt /> <strong>Адрес:</strong> Майкопский р-н, ст. Даховская, ул. Клубная, 16А</p>
          <p><FaPhone /> <strong>Телефон:</strong> <a href="tel:+79184249395">+7 (918) 424-93-95</a></p>
          <p>
            <FaTelegram /> <strong>Новости:</strong>{' '}
            <a href="https://t.me/dahovskayaGeorgiy" target="_blank" rel="noopener noreferrer">
              Telegram-канал прихода
            </a>
          </p>
        </Modal.Body>
      </Modal>

      <Modal show={showSchedule} onHide={() => setShowSchedule(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title>Расписание богослужений</Modal.Title>
        </Modal.Header>
        <Modal.Body className="church-modal-body">
          <div className="schedule-modal-grid">
            <div>
              <h4>Суббота</h4>
              <p>14:00 Панихида</p>
              <p>16:00 Вечерняя</p>
            </div>
            <div>
              <h4>Воскресенье</h4>
              <p>7:30 Исповедь</p>
              <p>8:00 Литургия</p>
            </div>
          </div>
          <p className="mb-0">Уточнить службу можно по телефону: <a href="tel:+79184249395">+7 (918) 424-93-95</a></p>
        </Modal.Body>
      </Modal>
    </header>
  );
}

export default Navig;
